import { Box, Typography, styled } from "@mui/material";
import React from "react";
import WorkCard from "./WorkCard";
import { workdata } from "../constants/workdata";

const WorkExperience = () => {
  const CustomBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  }));

  const CustomTitleBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
      gap: "2rem",
    },
  }));

  return (
    <Box sx={{ maxWidth: "1300px", mt: 10, mb: 6, padding: 3, mx: "auto" }}>
      <CustomTitleBox
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        <Typography
          variant="h4"
          style={{
            color: "white",
            textAlign: "center",
            fontFamily: "'Arvo', serif;'",
          }}
        >
          Arbetserfarenhet
        </Typography>
        <div
          style={{
            height: "5px",
            backgroundColor: "#B3565B",
            width: "50%",
            border: 0,
            borderRadius: "25px",
          }}
        ></div>
      </CustomTitleBox>

      <CustomBox sx={{ mt: 7, mb: 2 }}>
        {workdata.map((work) => (
          <WorkCard
            key={work.id}
            title={work.title}
            skills={work.skills}
            platform={work.platform}
            image={work.image}
            date={work.date}
            credential={work.credential}
          />
        ))}
      </CustomBox>
    </Box>
  );
};

export default WorkExperience;
